import numberChineseUnit from './module/numberChineseUnit'
import clipboard from './module/clipboard'
import loadmore from './module/loadmore'
import hasPermi from './module/hasPremi'

const directives = {
  numberChineseUnit,
  clipboard,
  loadmore,
  hasPermi,
}

export default directives